<template>
    <div class="row">
        <div class="col-12 col-lg-8">
            <div>
                <template v-if="event?.place?.tipo_proceso_online === 3">
                    <ul v-for="(entrada, index) in entradas" :key="index" class="resumen d-md-flex">
                        <li class="altcolor-content">
                            <div class="text-bold oswald text-uppercase m-0 w-100">
                                {{ ++index }}. {{ entrada.precioSeleccionado.descripcion }}
                                <template v-if="event?.reserva_instalaciones">
                                    ({{ event.fecha_sesion }})
                                </template>
                            </div>
                        </li>
                        <li class="flex-grow-1">
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                <template v-if="entrada.sector_name">
                                    Sector: {{ entrada.sector_name }} -
                                </template>
                                <template v-if="!event?.reserva_instalaciones">
                                    {{ $t('general.fila') }}: {{ entrada.fila }} - {{ $t('general.butaca') }}: {{ entrada.butaca }}
                                </template>
                                <template v-else>
                                    {{ entrada.name }}
                                </template>
                            </div>
                        </li>
                        <li v-if="entrada.visibilidad_reducida" class="p-0">
                            <div class="h7 text-bold oswald text-uppercase m-0 w-100">
                                <span v-if="entrada.visibilidad_reducida" class="text-danger">
                                    {{ $t('visibilidad_reducida.nombre') }}
                                </span>
                                <span v-if="entrada.porcentaje_visibilidad" class="text-danger">
                                    : {{ entrada.porcentaje_visibilidad }}%
                                </span>
                            </div>
                        </li>
                        <li class="text-bold pr-0">
                            <label class="h5 pr-0">{{ $t('general.precio') }}</label>
                            <div class="h5 m-lg-0">
                                {{ entrada.precio.precio | formatear_precio }}
                            </div>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <template v-if="entradas">
                        <ul v-for="(entrada, index) in entradas" :key="index" class="resumen d-md-flex">
                            <li class="altcolor-content">
                                <div class="text-bold oswald text-uppercase m-0 w-100">
                                    {{ ++index }}. {{ entrada.precio.descripcion }}
                                    <template v-if="event?.reserva_instalaciones">
                                        ({{ event.fecha_sesion }})
                                    </template>
                                </div>
                            </li>
                            <li>
                                <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                    {{ entrada.asiento ? entrada.asiento.zona_nombre : entrada.zona_nombre}}
                                </div>
                            </li>
                            <li>
                                <div class="h5 text-bold oswald text-uppercase m-0 w-100" v-if="!event?.reserva_instalaciones">
                                    <template v-if="!event?.reserva_instalaciones && entrada.asiento?.fila > 0 && entrada.asiento?.asiento > 0">
                                        {{ $t('general.fila') }}: {{ entrada.asiento ? entrada.asiento.fila : entrada.fila}} - {{ $t('general.butaca') }}:
                                        {{ entrada.asiento ? entrada.asiento.asiento : entrada.asiento}}                                    
                                    </template>
                                </div>
                            </li>
                            <li class="text-bold">
                                <label class="h5">{{ $t('general.precio') }}</label>
                                <div class="h4 mb-1">
                                    {{ entrada.precio.precio | formatear_precio }}
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template v-if="preciosPlazas">
                        <ul v-for="(entrada, index) in preciosPlazas" :key="index" class="resumen d-md-flex">
                            <li class="altcolor-content">
                                <div v-if="sectores">
                                    <div class="text-bold oswald text-uppercase m-0 w-100">
                                        {{ ++index }}. {{ entrada.descripcion }}
                                    </div>
                                </div>
                                <div v-else-if="!event?.reserva_instalaciones && entrada.fila && entrada.butaca">
                                    <div class="text-bold oswald text-uppercase m-0 w-100">
                                        {{ ++index }}. {{ entrada.descripcion}} - Fila: {{ entrada.fila }} - Asiento: {{ entrada.butaca }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="text-bold oswald text-uppercase m-0 w-100">
                                        {{ ++index }}. {{ entrada.descripcion }} - {{ entrada.nombrePlaza }}
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="h5 text-bold oswald text-uppercase m-0 w-100" v-if="!event?.reserva_instalaciones">
                                    {{ getButacaName(entrada) }}
                                </div>
                            </li>
                            <li class="text-bold">
                                <label class="h5">{{ $t('general.precio') }}</label>
                                <div class="h5 m-0">
                                    {{  entrada.precio | formatear_precio }}
                                </div>
                            </li>
                        </ul>
                    </template>
                </template>

                <template v-if="voucher">
                    <ul class="resumen d-md-flex">
                        <li class="altcolor-content">
                            <div class="text-bold oswald text-uppercase m-0 w-100">
                                {{ es_reserva ? $t('evento.discount') : $t("evento.voucher") }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ es_reserva ? $t('evento.discount') : $t("evento.voucher") }} -
                                {{ voucher.discount_percent != 0 ? voucher.discount_percent + "%" : voucher.discount_fixed + "€" }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ $t("evento.code") }}: {{ voucher.code }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ -voucher_discounted_total | formatear_precio }}
                            </div>
                        </li>

                    </ul>
                </template>

                <ResumenProductos v-if="productos && productos.length > 0" :productos="productos"/>

                <div class="mb-5">
                    <label>{{ $t('evento.total_pagar') }}</label>
                    <div class="price price-large gradient-color">
                        {{ total_price + coste_envio_whatsapp | formatear_precio }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="total > 0" class="col-12 col-lg-8">
            <slot name="afterSummary"></slot>
        </div>
        
        <div class="col-12 col-lg-8 mt-4">
            <FormTerminos 
                :error="error"
                @continuar="aceptarCondiciones"
                :desactivar="desactivar"
            />
        </div>
        <b-col cols="12">
            <ResumenPrecioComponent
                :key="gastos"
                :price="(total + totalPlazas + calcularTotalProductosSinManagement()) - voucher_discounted_total"
                :price_management="gastos"
                :price_management_interno="price_management_interno_resumen"
                :iva="event != undefined && event.experiencia ? footer.iva_experiencia : footer.iva_partido"
            />
        </b-col>
        <div class="col-12 mt-4 d-flex">
            <button 
                v-if="total_price > 0"
                :disabled="procesar_pago"
                :class="['button','compra-responsive', { 'effect-button': !procesar_pago }, !esMovil ? 'large-button effect-button' : '']"
                @click.prevent="terminar"
                id="resumen-continuar"
            >
                <span>{{ $t('partido.continuar') }}</span>
            </button>
            <button
                v-else
                :disabled="loading || desactivar"
                :class="['button', { 'effect-button': !(loading || desactivar) }, !esMovil ? 'large-button effect-button' : '']"
                @click.prevent="terminar"
            >
                <span>{{ $t('evento.descargar_entradas') }}</span>
            </button>
            <button 
                :disabled="loading || desactivar"
                :class="['button', 'ml-2', 'compra-responsive', { 'effect-button': !(loading || desactivar) }, !esMovil ? 'large-button effect-button' : '']"
                @click.prevent="volver()"
            >
                <span>{{ $t('formularios.atras') }}</span>
            </button>
            <template v-if="formulario != null" >
                <div id="formulario-compra" v-html="formulario" v-show="false">
                </div>
            </template>

            <SendFacebookPetition 
                v-if="pixel_id && event" 
                :evento_id="String(event.id)"
                event_name="AddToCart"
                :evento_name="event.name"
                :nombre="localDatos.nombre"
                :apellidos="localDatos.apellidos" 
                :email="localDatos.email"
                :quantity="entradas.length + (Array.isArray(entradasPlazas) ? entradasPlazas.length : 0)" 
                :total="total_con_gd - voucher_discounted_total" 
                :url_evento="url"
                :user_order="session_id"
                :cp="localDatos.cp"
            />
        </div>
    </div>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import SendFacebookPetition from "@/components/common/SendFacebookPetition";
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import ResumenProductos from './components/productos/ResumenProductos.vue';

    export default {
        props: ['entradas', 'formulario', 'productos', "voucher", 'event', 'datos', 'session_id', 'entradasPlazas', 'desactivar', 'sectores'],
        data() {
            return {
                noTieneTelefono: false,
                error: false,
                terminos: false,
                loading: false,
                pixel_id: process.env.VUE_APP_PIXEL_ID,
                procesar_pago: false,
                isValidNumber: this.datos.telefono ? true : false,
                esMovil: false,
                localDatos: this.datos
            }
        },
        computed: {
            es_reserva() {
                return window.location.href.includes('reservas');
            },
            preciosPlazas() {
                if (this.entradasPlazas && this.entradasPlazas.length > 0) {
                    return this.entradasPlazas.map(plaza => {
                        return {
                            ...plaza.precioSeleccionado,
                            nombrePlaza: plaza.name,
                            sector: plaza.sector,
                            fila: plaza.fila,
                            butaca: plaza.butaca
                        }
                    });
                }

                return [];
            },
            price_management_interno_resumen() {
                if (this.entradas.length > 0) {
                    return this.entradas[0].precio.gd_interno
                }

                if (this.entradasPlazas && this.entradasPlazas.length > 0) {
                    return this.entradasPlazas[0].price_management_interno;
                }

                return 0;
            },
            url() {
                return window.location.href;
            },
            total_con_gd() {
                let total = 0;
                for(var i in this.entradas) {
                    total = total + parseFloat(this.entradas[i].precio.precio_total);
                }

                return total;
            },
            total() {
                var total = 0;
                for(var i in this.entradas) {
                    total = total + parseFloat(this.entradas[i].precio.precio);
                }

                return total;
            },
            totalPlazas() {
                if (this.entradasPlazas) {
                    if (this.entradasPlazas.length === 0) return 0;
                    return parseFloat(this.preciosPlazas.reduce((total, entrada) => total + entrada.precio, 0));
                }

                return 0;
            },
            total_gd() {
                var total = 0;
                for(var i in this.entradas) {
                    total = total + parseFloat(this.entradas[i].precio.gd);
                }

                return total;
            },
            totalPlazas_gd() {
                if (this.entradasPlazas) {
                    if (this.entradasPlazas && this.entradasPlazas.length === 0) return 0;
                    return parseFloat(this.preciosPlazas.reduce((total, entrada) => total + entrada.price_management_online, 0));
                }

                return 0;
            },
            gastos() {
                let gds = this.total_gd + this.totalPlazas_gd;

                if (this.productos && this.productos.length > 0) {
                    gds += this.productos.reduce((total, producto) => {
                        const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                        return total + (priceManagement * producto.units);
                    }, 0);
                }

                gds += this.coste_envio_whatsapp;

                return gds;
            },
            totalPlazas_con_gd() {
                if (this.entradasPlazas) {
                    if (this.entradasPlazas && this.entradasPlazas.length === 0) return 0;
                    return parseFloat(this.preciosPlazas.reduce((total, entrada) => total + (entrada.precio + entrada.price_management_online), 0));
                }
                return 0;
            },
            voucher_discounted_total() {
                if(!this.voucher) return 0;

                var total = 0;
                var voucher_units = this.voucher.units;

                for(var entrada of this.entradas) {
                    if(voucher_units <= 0) break;
                    voucher_units--;


                    if(this.voucher.discount_percent > 0) {
                        total += (this.voucher.discount_percent / 100) * parseFloat(entrada.precio.precio);
                    } else {
                        total += parseFloat(this.voucher.discount_fixed);
                    }
                }

                return total;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            total_price() {
                let entradas = 0;
                let entradasPlazas = 0;
                let productos = 0;
        
                if (this.entradas && this.entradas.length > 0) {
                    entradas = (this.entradas[0]?.precio.gd_interno ? (this.total) : (this.total_con_gd)) - this.voucher_discounted_total;
                }

                if (this.entradasPlazas && this.entradasPlazas.length > 0) {
                    entradasPlazas = this.preciosPlazas[0]?.price_management_interno ? this.totalPlazas : this.totalPlazas_con_gd;
                }

                if (this.productos && this.productos.length > 0) {
                    productos = this.calcularTotalProductos();
                }

                return entradas + entradasPlazas + productos;
            },
            coste_envio_whatsapp() {
                return parseFloat(this.teatro.coste_envio_whatsapp);
            }
        },
        methods: {
            calcularTotalProductos() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                    return acc + (producto.item.price * producto.units) + (priceManagement * producto.units);
                }, 0);
            },
            calcularTotalProductosSinManagement() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    return acc + (producto.item.price * producto.units);
                }, 0);
            },
            terminar() {
                this.loading = true;
                if (this.terminos == true && !this.noTieneTelefono) {
                    this.guardarTerminosCondiciones();
                    this.$emit('terminar', this.datos);
                    if (this.formulario) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 500);                    
                    } else if (this.total_price == 0) {
                        this.$emit('terminado', true);
                    } else {
                        this.procesar_pago = true;
                        this.$emit('terminado');
                    }
                } else {
                    this.loading = false;
                    this.error = true;
                }
                    
            },
            guardarDatos() {
                if (!isNaN(this.localDatos.telefono) && this.localDatos.telefono) {
                    this.$emit('terminar', this.datos);
                    this.noTieneTelefono = false;
                } else {
                    this.noTieneTelefono = true;
                }
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.localDatos.privacidad = privacidad;
                this.localDatos.condiciones = condiciones;
                this.localDatos.comunicaciones = comunicaciones;
                this.terminos = continuar == true;
            },
            guardarTerminosCondiciones(){
                const params = {
                    filters: {},
                    privacidad: this.datos.privacidad,
                    condiciones: this.datos.condiciones,
                    comunicaciones: this.datos.comunicaciones,
                    session_id: this.session_id,
                }	
                this.$store.dispatch(this.config.getVuexAlias('front.guardar.terminos.condiciones'), params).catch(error => {
                    this.$toast.error('Error al guardar los terminos y condiciones');
                });
            },
            volver() {
                this.$emit('volver');
            },
            getButacaName(plaza) {
                if (!plaza.butaca) {
                    return `${this.$t('general.butaca')}: ${plaza.nombrePlaza}`;
                } else {
                    const nButaca = plaza.butaca;
                    const nFila = plaza.fila;
                    const sector = plaza.sector_name;
                    let name = '';

                    if(sector) {
                        name += `${this.$t('general.sector')}: ${sector} - `;
                    }                     
        
                    return name += `${this.$t('general.fila')}: ${nFila} - ${this.$t('general.butaca')}: ${nButaca}`
                }
            },
            handleValidNumber(isValid) {
                this.isValidNumber = isValid;

                if (isValid) {
                    this.guardarDatos();
                }
            },
            onResize() {
                this.esMovil = window.innerWidth < 768;
            },
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true });
            }
        },
        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
        },
        components: {
            ResumenPrecioComponent,
            FormTerminos, SendFacebookPetition, ResumenProductos
        }
    }
</script>